<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server">
                        <template #filters>
                            <payments-filter v-on:filter="filter" v-on:download="download"></payments-filter>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import Additional from '@/utilities/additional'
import { BCard } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
import PaymentsFilter from './components/PaymentsFilter.vue'
export default {
    components:{
        BCard,
        PaymentsFilter
    },
    data(){
        return {
            fields:[
                {name:"Dekont", key:'SystemReceiptCode', component:true, componentOptions:{ name:'payment/PaymentReceipt' },thClass:'w-10'},
                {name:'Müşteri E-Posta',key:'CustomerEmail',thClass:'w-15',tdClass:'text-nowrap'},
                {name:'Müşteri Adı',key:'CustomerFullName',thClass:'w-20',tdClass:'text-nowrap'},
                {name:'İşlem Başlama Tarihi',key:'CreateTime',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Ödeme İşlemi Tarihi',key:'PaymentTime',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Tutar (TL)',key:'Amount',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Taksit',key:'Installment',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Banka',key:'Bank',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Tamamlandı',key:'IsCompleted',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Ödeme Başarılı',key:'IsPaymentSuccessfull',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Banka Hata - 1',key:'BankError',thClass:'w-10'},
                {name:'Banka Hata - 2',key:'BankError2',thClass:'w-10',tdClass:'text-nowrap'},
            ],
            buttons:[
                { text:"İptal Et",key:"cancel",icon:"LockIcon",variant:"primary",action:this.cancelPayment,condition:(item) => !item.IsCanceled },
                { text:"İptal Edildi",key:"cancel",icon:"TrashIcon",variant:"secondary",condition:(item) => item.IsCanceled },
            ],
            filterData:{
                CreateTimeStart :null,
                CreateTimeEnd :null,
                IsCompleted :null,
                IsPaymentSuccessfull :null,
                PlasiyerId :null,
            },
            loading:false,
            paginationData:null
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            this.paginationData = data
            return PaymentApi.List({
                Pagination:data,
                ...this.filterData
            })
        },
        cancelPayment(item){
            this.$refs.table.rowLoading(true)
            PaymentApi.CancelPayment(item.Id).then(res=>{
                this.$result(res)
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        download(){
            let d = {
                Pagination:this.paginationData,
                ...this.filterData
            }
            PaymentApi.DownloadList(d).then(res => {
                console.log(res.data)
                Additional.GetBlobFile(res.data.File).then(sres=>{
                    console.log(res)
                    Additional.DownloadFile(sres.data,res.data.Name)
                })
            })
        }
    }
}
</script>

<style>

</style>